// extracted by mini-css-extract-plugin
export default {"section-header":"SAMLRegForm_section-header__vdkPt","submit-button":"SAMLRegForm_submit-button__AETYR","helper-text":"SAMLRegForm_helper-text__czymb"};